import { Injectable } from '@angular/core';
import { environment } from '@env';
import { HttpHandlerService } from '@shared/services/http-handler.service';

const BASE_URL = `${environment.serviceUrl}/api/v1/salesforce`;
const SALESFORCE_URL = `${environment.urlSalesforce}/api/v1/salesforce`;

@Injectable({ providedIn: 'root' })
export class SalesforceService {

    constructor(private http: HttpHandlerService) { }

    public export(cnpjContabilidade: string, cnpjEmpresa: string, tipoLancamento: 1 | 2) {
        const url = `${BASE_URL}/envia_regras`;
        const params = { cnpjContabilidade, cnpjEmpresa, tipoMovimento: tipoLancamento };
        return this.http.patch([url, params], {}, 'Falha na exportação!');
    }

    public registerNps(grade: number, description: string) {
        const url = `${BASE_URL}/nps`;
        const body = { Nota__c: grade, Observacoes__c: description || '' };
        return this.http.request(url)
            .setBody(body)
            .setSuccesMessage('Agradecemos pelo feedback :)')
            .post();
    }

    public getAccountancy(cnpj: string) {
        const url = `${SALESFORCE_URL}/sobjects/Contabilidade__c/CNPJ_Numeros__c/${cnpj}`;
        return this.http.request(url)
            .setErrorMessage('Falha ao buscar contabilidade no Salesforce')
            .get();
    }

}
